import { render, staticRenderFns } from "./InstallationDefectedItems.vue?vue&type=template&id=f4cb97d6&scoped=true"
import script from "./InstallationDefectedItems.vue?vue&type=script&lang=js"
export * from "./InstallationDefectedItems.vue?vue&type=script&lang=js"
import style0 from "./InstallationDefectedItems.vue?vue&type=style&index=0&id=f4cb97d6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4cb97d6",
  null
  
)

export default component.exports